// Philippines Employee Benefits Cover Details Mock Data

export const CountryOptions = [
  {label: "PHILIPPINES",value: "PHILIPPINES"}
  ];
  export const CityOptions = [
  

  { label: 'MATI', value: 'MATI' },
  { label: 'DON SALVADOR BENEDICTO', value: 'DON SALVADOR BENEDICTO' },
  { label: 'SANTA TERESITA', value: 'SANTA TERESITA' },
  { label: 'SANTOL', value: 'SANTOL' },
  { label: 'STO. CRISTO', value: 'STO. CRISTO' },
  { label: 'STO. NIÑO', value: 'STO. NIÑO' },
  { label: 'SAUYO', value: 'SAUYO' },
  { label: 'SIENNA', value: 'SIENNA' },
  { label: 'SIKATUNA VILLAGE', value: 'SIKATUNA VILLAGE' },
  { label: 'SILANGAN', value: 'SILANGAN' },
  { label: 'SOCORRO', value: 'SOCORRO' },
  { label: 'SOUTH TRIANGLE', value: 'SOUTH TRIANGLE' },
  { label: 'TAGUMPAY', value: 'TAGUMPAY' },
  { label: 'TALAMPAS', value: 'TALAMPAS' },
  { label: 'TALAYAN', value: 'TALAYAN' },
  { label: 'TALIPAPA', value: 'TALIPAPA' },
  { label: 'TANDANG SORA', value: 'TANDANG SORA' },
  { label: 'TATALON', value: 'TATALON' },
  { label: 'TEACHERS VILLAGE', value: 'TEACHERS VILLAGE' },
  { label: 'UGONG NORTE', value: 'UGONG NORTE' },
  { label: 'UNANG SIGAW', value: 'UNANG SIGAW' },
  { label: 'U.P.P.O.', value: 'U.P.P.O.' },
  { label: 'U.P. VILLAGE', value: 'U.P. VILLAGE' },
  { label: 'VALENCIA', value: 'VALENCIA' },
  { label: 'VASRA', value: 'VASRA' },
  { label: 'VETERANS VILLAGE', value: 'VETERANS VILLAGE' },
  { label: 'VILLA MARIA CLARA', value: 'VILLA MARIA CLARA' },
  { label: 'VIOLAGO HOMES', value: 'VIOLAGO HOMES' },
  { label: 'WEST TRIANGLE', value: 'WEST TRIANGLE' },
  { label: 'WHITE PLAINS', value: 'WHITE PLAINS' },
  { label: 'BRAULIO E. DUJALI', value: 'BRAULIO E. DUJALI' },
  { label: 'NAUJAN', value: 'NAUJAN' },
  { label: 'TAMPARAN', value: 'TAMPARAN' },
  { label: 'TARAKA', value: 'TARAKA' },
  { label: 'WAO', value: 'WAO' },
  { label: 'AGOO', value: 'AGOO' },
  { label: 'ARINGAY', value: 'ARINGAY' },
  { label: 'BACNOTAN', value: 'BACNOTAN' },
  { label: 'BAGULIN', value: 'BAGULIN' },
  { label: 'BALAOAN', value: 'BALAOAN' },
  { label: 'BANGAR', value: 'BANGAR' },
  { label: 'BAUANG', value: 'BAUANG' },
  { label: 'BURGOS', value: 'BURGOS' },
  { label: 'CABA', value: 'CABA' },
  { label: 'DAMORTIS', value: 'DAMORTIS' },
  { label: 'LUNA', value: 'LUNA' },
  { label: 'NAGUILLAN', value: 'NAGUILLAN' },
  { label: 'PUGO', value: 'PUGO' },
  { label: 'ROSARIO', value: 'ROSARIO' },
  { label: 'SAN FERNANDO', value: 'SAN FERNANDO' },
  { label: 'SAN GABRIEL', value: 'SAN GABRIEL' },
  { label: 'SAN JUAN', value: 'SAN JUAN' },
  { label: 'SANTOL', value: 'SANTOL' },
  { label: 'SANTO TOMAS', value: 'SANTO TOMAS' },
  { label: 'SUDEPEN', value: 'SUDEPEN' },
  { label: 'TUBAO', value: 'TUBAO' },
  { label: 'ABUYOG', value: 'ABUYOG' },
  { label: 'ALANGALANG', value: 'ALANGALANG' },
  { label: 'ALBUERA', value: 'ALBUERA' },
  { label: 'BABATNGON', value: 'BABATNGON' },
  { label: 'BARUGO', value: 'BARUGO' },
  { label: 'BATO', value: 'BATO' },
  { label: 'BAYBAY', value: 'BAYBAY' },
  { label: 'BURAUEN', value: 'BURAUEN' },
  { label: 'CALUBIAN', value: 'CALUBIAN' },
  { label: 'CAPOOCAN', value: 'CAPOOCAN' },
  { label: 'CARIGARA', value: 'CARIGARA' },
  { label: 'DAGAMI', value: 'DAGAMI' },
  { label: 'DULAG', value: 'DULAG' },
  { label: 'HILONGOS', value: 'HILONGOS' },
  { label: 'HINDANG', value: 'HINDANG' },
  { label: 'INOPACAN', value: 'INOPACAN' },
  { label: 'ISABEL', value: 'ISABEL' },
  { label: 'JARO', value: 'JARO' },
  { label: 'JAVIER', value: 'JAVIER' },
  { label: 'JULITA', value: 'JULITA' },
  { label: 'KANANGA', value: 'KANANGA' },
  { label: 'LA PAZ', value: 'LA PAZ' },
  { label: 'LEYTE', value: 'LEYTE' },
  { label: 'GENERAL MAC ARTHUR', value: 'GENERAL MAC ARTHUR' },
  { label: 'MAHAPLAG', value: 'MAHAPLAG' },
  { label: 'MATAG-OB', value: 'MATAG-OB' },
  { label: 'MATALOM', value: 'MATALOM' },
  { label: 'MAYORGA', value: 'MAYORGA' },
  { label: 'PULANG LUPA & ZAPOTE', value: 'PULANG LUPA & ZAPOTE' },
  { label: 'PULANG LUPA', value: 'PULANG LUPA' },
  { label: 'AYALA', value: 'AYALA' },
  { label: 'PASEO DE ROXAS', value: 'PASEO DE ROXAS' },
  { label: 'BANGKAL', value: 'BANGKAL' },
  { label: 'BEL-AIR', value: 'BEL-AIR' },
  { label: 'CEMBO', value: 'CEMBO' },
  { label: 'PANITAN', value: 'PANITAN' },
  { label: 'PILAR', value: 'PILAR' },
  { label: 'PRES. ROXAS', value: 'PRES. ROXAS' },
  { label: 'PUNTEVEDRA', value: 'PUNTEVEDRA' },
  { label: 'ROXAS CITY', value: 'ROXAS CITY' },
  { label: 'SAPIAN', value: 'SAPIAN' },
  { label: 'TAPAZ', value: 'TAPAZ' },
  { label: 'BAGAMANOC', value: 'BAGAMANOC' },
  { label: 'BARAS', value: 'BARAS' },



  ];
  export const ProvinceOptions = [
  
    
      {label:"DAVAO ORIENTAL",value:"DAVAO ORIENTAL"},
      "NEGROS OCCIDENTAL",
      "QUEZON CITY",
      "DAVAO DEL NORTE",
      "ORIENTAL MINDORO",
      "LA UNION",
      "LEYTE",
      "LAS PINAS CITY",
      "MAKATI CITY",
      "CAPIZ",
      "CATANDUANES",
      "ILOCOS SUR",
      "ILOILO",
      "ZAMBOANGA DEL NORTE",
      "ZAMBOANGA DEL SUR",
      "QUEZON PROVINCE",
      "PANGASINAN",
      "BOHOL",
      "CAVITE",
      "DAVAO DE ORO",
      "CEBU",
      "MISAMIS ORIENTAL",
      "BASILAN",
      "QUIRINO PROVINCE",
      "ISABELA",
      "BUKIDNON",
      "MALABON CITY",
      "MANDALUYONG CITY",
      "MOUNTAIN PROVINCE",
      "ABRA",
      "AGUSAN DEL NORTE",
      "AGUSAN DEL SUR",
      "AKLAN",
      "MARIKINA CITY",
      "BULACAN",
      "COTABATO",
      "NEGROS ORIENTAL",
      "LAGUNA",
      "KALINGA",
      "APAYAO",
      "CAGAYAN",
      "SOUTHERN LEYTE",
      "MAGUINDANAO",
      "NUEVA ECIJA",
      "RIZAL PROVINCE",
      "ROMBLON",
      "EASTERN SAMAR",
      "ALBAY",
      "ANTIQUE",
      "AURORA",
      "BATAAN",
      "CAMARINES NORTE",
      "CAMARINES SUR",
      "NUEVA VIZCAYA",
      "PALAWAN",
      "NORTHERN SAMAR",
      "SAMAR",
      "LANAO DEL NORTE",
      "CITY OF MANILA",
      "CALOOCAN CITY",
      "MARINDUQUE",
      "MASBATE",
      "OCCIDENTAL MINDORO",
      "MUNTINLUPA CITY",
      "SAN JUAN CITY",
      "SARANGANI",
      "SIQUIJOR",
      "SORSOGON",
      "SULTAN KUDARAT",
      "BATANES",
      "BATANGAS",
      "PAMPANGA",
      "NAVOTAS CITY",
      "PARANAQUE CITY",
      "MISAMIS OCCIDENTAL",
      "TAGUIG CITY",
      "SOUTH COTABATO",
      "DAVAO DEL SUR",
      "DAVAO OCCIDENTAL",
      "SULU PROVINCE",
      "SURIGAO DEL NORTE",
      "DINAGAT ISLANDS",
      "SURIGAO DEL SUR",
      "BENGUET",
      "BILIRAN",
      "PASAY CITY",
      "VALENZUELA CITY",
      "TARLAC",
      "TAWI-TAWI",
      "ZAMBALES",
      "PASIG CITY",
      "PATEROS CITY",
      "CAMIGUIN",
      "GUIMARAS",
      "IFUGAO",
      "ILOCOS NORTE"
  
  

  
  ];

  export const TNVSOptions = [
    { label: "True", value: "True" },
    { label: "False", value: "False" },
  ];
  
  export const MortgageOptions = [
    { label: "BDO UNIBANK, INC.", value: "BDO UNIBANK, INC." },
    { label: "METROPOLITAN BANK & TRUST CO.", value: "METROPOLITAN BANK & TRUST CO." },
    { label: "BANK OF THE PHILIPPINE ISLANDS", value: "BANK OF THE PHILIPPINE ISLANDS" },
    { label: "CHINA BANKING CORPORATION", value: "CHINA BANKING CORPORATION" },
    { label: "SECURITY BANK CORPORATION", value: "SECURITY BANK CORPORATION" },
    { label: "PHILIPPINE NATIONAL BANK", value: "PHILIPPINE NATIONAL BANK" },
    { label: "UNION BANK OF THE PHILIPPINES", value: "UNION BANK OF THE PHILIPPINES" },
  ]; 


  export const VehicleBrandOptions = [
    { label: "Toyota", value: "Toyota" },
    { label: "Honda", value: "Honda" },
    { label: "Mitsubishi", value: "Mitsubishi" },
    { label: "Nissan", value: "Nissan" },
    { label: "Ford", value: "Ford" },
    { label: "Hyundai", value: "Hyundai" },
    { label: "Isuzu", value: "Isuzu" },
    { label: "Suzuki", value: "Suzuki" },
    { label: "Mazda", value: "Mazda" },
    { label: "Kia", value: "Kia" },
  ];

  export const ModelYearOptions = [
    { label: "2025", value: "2025" },
    { label: "2024", value: "2024" },
    { label: "2023", value: "2023" },
    { label: "2022", value: "2022" },
    { label: "2021", value: "2021" },
    { label: "2020", value: "2020" },
  ];

  export const ModelVariantOptions = [
    { label: "Sedan", value: "Sedan" },
    { label: "Hatchback", value: "Hatchback" },
    { label: "SUV", value: "SUV" },
    { label: "Coupe", value: "Coupe" },
  ];

  export const VehicleModelOptions = [
    { label: "Vios", value: "Vios" },
    { label: "Hilux", value: "Hilux" },
    { label: "Fortuner", value: "Fortuner" },
    { label: "Civic", value: "Civic" },
    { label: "CR-V", value: "CR-V" },
    { label: "City", value: "City" },
    { label: "Mirage", value: "Mirage" },
    { label: "Montero Sport", value: "Montero Sport" },
    { label: "Ranger", value: "Ranger" },
    { label: "EcoSport", value: "EcoSport" },
  ];

  export const VehicleColorOptions = [
    { label: "Red", value: "Red" },
    { label: "Blue", value: "Blue" },
    { label: "Black", value: "Black" },
    { label: "White", value: "White" },
  ];

  export const ActsofnatureRateOptions = [
    { label: "₱100,000", value: "100000" },
    { label: "₱200,000", value: "200000" },
    { label: "₱300,000", value: "300000" },
    { label: "₱500,000", value: "500000" },
    { label: "₱750,000", value: "750000" },
    { label: "₱1,000,000", value: "1000000" },
  ];


  export const covers = [
    { label: "Employer’s Liability (Annual Limit)", value: "Employer’s Liability (Annual Limit)" },
    { label: "Medical Expenses", value: "Medical Expenses" },
    { label: "Any One Occurrence Limit – Employers", value: "Any One Occurrence Limit – Employers" },
    { label: "PA (Personal Accident)", value: "PA (Personal Accident)" },
  ];
  export const BodilyInjuryOptions = [
   { label: "₱50,000", value: "50000" },
    { label: "₱100,000", value: "100000" },
    { label: "₱250,000", value: "250000" },
    { label: "₱500,000", value: "500000" },
    { label: "₱750,000", value: "750000" },
  ];
  

  export const PremiumOPtions = [
    { label: "Flat rate × Employee count", value: "Flat rate × Employee count" },
    { label: "Salary-based % × Total payroll", value: "Salary-based % × Total payroll" },
    { label: "Per-Employee Sum Insured × Rate", value: "Per-Employee Sum Insured × Rate" },
   ];
  export const PropertyDamageOptions = [
    { label: "₱50,000", value: "50000" },
    { label: "₱100,000", value: "100000" },
    { label: "₱250,000", value: "250000" },
    { label: "₱500,000", value: "500000" },
    { label: "₱750,000", value: "750000" },
  ];
  

  export const AutopassengerpersonalAccidentOptions = [
    { label: "₱50,000", value: "50000" },
    { label: "₱100,000", value: "100000" },
    { label: "₱250,000", value: "250000" },
    { label: "₱500,000", value: "500000" },
    { label: "₱750,000", value: "750000" },
  ];

  export const APPATotalCoverageOptions = [
    { label: "₱100,000", value: "100000" },
    { label: "₱250,000", value: "250000" },
    { label: "₱500,000", value: "500000" },
    { label: "₱750,000", value: "750000" },
    { label: "₱1,000,000", value: "1000000" },
  ];


  export const LossandDamagecoverageRateOptions = [
    { label: "₱100,000", value: "100000" },
    { label: "₱250,000", value: "250000" },
    { label: "₱500,000", value: "500000" },
    { label: "₱750,000", value: "750000" },
    { label: "₱1,000,000", value: "1000000" },
  ];
  

  export const AuthorizedSignatureOptions = [
    { label: "Juan Dela Cruz", value: "Juan Dela Cruz" },
    { label: "Maria Santos", value: "Maria Santos"},
    { label: "Roberto Reyes", value: "Roberto Reyes"},
    { label: "Ana Garcia", value: "Ana Garcia"},
    { label: "Miguel Torres", value: "Miguel Torres"},

  ];

 